import type { FC, ReactNode } from 'react';

import { HtmlFontsConfig } from './html-fonts-config';
import { HtmlTitleConfig } from './html-title-config';

interface Props {
  children: ReactNode;
}

export const HtmlConfigProvider: FC<Props> = ({ children }) => (
  <>
    <HtmlFontsConfig />
    <HtmlTitleConfig title="Savvy" />
    {children}
  </>
);
